<template>
  <div>
    <p class="font-weight-bold"><i :class="` ${icon} mr-2 c-orange fs-18`"></i>{{ label }}</p>
    <p v-html="value"></p>
  </div>
</template>

<script>
export default {
  name: 'Info',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
  },
}
</script>
